import React from 'react';

export type Props = {
  className?: string;
  fill?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

export const Globe = React.memo((props: Props) => {
  const {
    width,
    height,
    className,
    onClick,
    fill,
  } = props;

  return (
    <svg
      width={width || 22}
      height={height || 22}
      className={className}
      onClick={onClick}
      viewBox={'0 0 22 22'}
    >
      <path d='M11 0C8.08263 0 5.28511 1.15908 3.22254 3.22254C1.15908 5.28498 0 8.08263 0 11C0 13.9174 1.15908 16.7149 3.22254 18.7775C5.28498 20.8409 8.08263 22 11 22C13.9174 22 16.7149 20.8409 18.7775 18.7775C20.8409 16.715 22 13.9174 22 11C22 8.08263 20.8409 5.28511 18.7775 3.22254C16.715 1.15908 13.9174 0 11 0ZM18.6114 6.59979H15.4382C15.233 5.3118 14.8628 4.05475 14.3379 2.86061C16.1343 3.60412 17.6357 4.91893 18.6114 6.59979ZM19.7994 11C19.7983 11.7425 19.7004 12.4829 19.5086 13.1996H15.719C15.7798 12.4736 15.8128 11.7363 15.8128 11C15.8128 10.2627 15.7798 9.5264 15.719 8.80042H19.5086C19.7004 9.51711 19.7983 10.2575 19.7994 11ZM11 19.7994C10.3617 19.7994 9.35005 18.1938 8.80042 15.3992H13.2006C12.65 18.1938 11.6383 19.7994 11 19.7994H11ZM8.48693 13.1996C8.42609 12.5117 8.38794 11.7806 8.38794 11C8.38794 10.2194 8.42609 9.4872 8.48693 8.80042H13.5141C13.575 9.48825 13.6131 10.2194 13.6131 11C13.6131 11.7806 13.575 12.5128 13.5141 13.1996H8.48693ZM2.20077 11C2.2018 10.2575 2.29976 9.51711 2.49158 8.80042H6.28118C6.22034 9.5264 6.18734 10.2637 6.18734 11C6.18734 11.7373 6.22034 12.4736 6.28118 13.1996H2.49158C2.29977 12.4829 2.2018 11.7425 2.20077 11ZM11.0001 2.20063C11.6385 2.20063 12.6501 3.80623 13.1997 6.60084L8.80055 6.59981C9.35018 3.80625 10.3618 2.20066 11.0001 2.20066V2.20063ZM7.66196 2.86061C7.13706 4.05475 6.76687 5.31183 6.56164 6.59979H3.38846C4.36399 4.9189 5.86544 3.60401 7.66196 2.86061ZM3.38846 15.4002H6.56164C6.76685 16.6882 7.13706 17.9452 7.66196 19.1394C5.86558 18.3959 4.36418 17.0811 3.38846 15.4002ZM14.3388 19.1404L14.3378 19.1394C14.8627 17.9453 15.2329 16.6882 15.4381 15.4002H18.6113C17.6358 17.0811 16.1343 18.396 14.3378 19.1394L14.3388 19.1404Z' fill={fill || 'white'}/>
    </svg>
  );
});

Globe.displayName = 'Globe';
